export default __webpack_public_path__ + "static/media/coffee-good-idea.44297704.webp";